
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardContent } from '@/components/ui/card';
import { Activity, Zap, Gauge, AlertCircle, Lightbulb, TrendingDown } from 'lucide-react';

const StatCards = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <AnimatedCard 
        animation="fade-up" 
        delay={100}
        className="bg-white dark:from-gray-800/90 dark:to-gray-800/70 border border-gray-200 dark:border-gray-700 shadow-lg rounded-lg overflow-hidden"
      >
        <CardContent className="p-6 flex flex-col items-center">
          <div className="bg-blue-50 dark:bg-blue-900/30 p-3 rounded-full mb-4">
            <Lightbulb className="h-6 w-6 text-energy-blue" />
          </div>
          <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">Optimization Potential</h3>
          <p className="text-3xl font-bold mt-2 text-energy-blue dark:text-energy-lightBlue">15.3%</p>
          <p className="text-sm text-green-600 mt-1 flex items-center font-medium">
            <span>Based on AI analysis</span>
          </p>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up" 
        delay={200}
        className="bg-white dark:from-gray-800/90 dark:to-gray-800/70 border border-gray-200 dark:border-gray-700 shadow-lg rounded-lg overflow-hidden"
      >
        <CardContent className="p-6 flex flex-col items-center">
          <div className="bg-red-50 dark:bg-red-900/30 p-3 rounded-full mb-4">
            <TrendingDown className="h-6 w-6 text-energy-red" />
          </div>
          <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">Predicted Savings</h3>
          <p className="text-3xl font-bold mt-2 text-energy-red">$1,240</p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 font-medium">Monthly if optimized</p>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up" 
        delay={300}
        className="bg-white dark:from-gray-800/90 dark:to-gray-800/70 border border-gray-200 dark:border-gray-700 shadow-lg rounded-lg overflow-hidden"
      >
        <CardContent className="p-6 flex flex-col items-center">
          <div className="bg-green-50 dark:bg-green-900/30 p-3 rounded-full mb-4">
            <Gauge className="h-6 w-6 text-energy-green" />
          </div>
          <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">System Efficiency</h3>
          <p className="text-3xl font-bold mt-2 text-energy-green">86%</p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 font-medium">Target: 92%</p>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up" 
        delay={400}
        className="bg-white dark:from-gray-800/90 dark:to-gray-800/70 border border-gray-200 dark:border-gray-700 shadow-lg rounded-lg overflow-hidden"
      >
        <CardContent className="p-6 flex flex-col items-center">
          <div className="bg-amber-50 dark:bg-amber-900/30 p-3 rounded-full mb-4">
            <AlertCircle className="h-6 w-6 text-amber-500" />
          </div>
          <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">Pending Actions</h3>
          <p className="text-3xl font-bold mt-2 text-amber-500">4</p>
          <p className="text-sm text-red-500 mt-1 font-medium">1 high priority</p>
        </CardContent>
      </AnimatedCard>
    </div>
  );
};

export default StatCards;
